import AddressSettings from './AddressSettings.vue';

export default AddressSettings;



// WEBPACK FOOTER //
// ./src/pages/profile/views/address/index.ts